// Blog byline resolution, shared so the visible byline microdata and the
// BlogPosting JSON-LD never disagree on the author's schema.org @type.
//
// The WP post author flows through blog.author (blog.service.ts maps
// post.author.node.name, defaulting to 'GearFocus'). A named human byline is a
// schema.org Person; the brand/staff bylines stay Organization. Backward-
// compatible: until the pipeline assigns real authors, blog.author is
// 'GearFocus' and this returns the Organization the page used before.

export const ORG_BYLINES = new Set([
  'GearFocus',
  'GearFocus Staff Writer',
  'Staff Writer',
]);

export type BlogAuthor = { name: string; type: 'Organization' | 'Person' };

export function resolveBlogAuthor(name?: string): BlogAuthor {
  const n = (name || '').trim();
  if (!n || ORG_BYLINES.has(n)) {
    return { name: 'GearFocus', type: 'Organization' };
  }
  return { name: n, type: 'Person' };
}
